
import { createContext } from "react";

export const SearchContext = createContext<SearchContextType>({
    search: "",
    setSearch: (val) => ""
});

export type SearchContextType = {
    search: string;
    setSearch: (val: string) => void;
};